"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCell = void 0;
const react_1 = __importStar(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const tooltip_1 = require("../../tooltip/tooltip");
const tooltip_field_hook_1 = require("../../tooltip/tooltip-field-hook");
const table_field_styles_1 = require("../table-field-styles");
exports.TextCell = (0, react_1.memo)(function TextCell({ value, }) {
    const classes = (0, table_field_styles_1.useStyles)();
    const { withTooltip, tooltipRef } = (0, tooltip_field_hook_1.useFieldTooltip)(value);
    const content = (react_1.default.createElement(Typography_1.default, { className: classes.tableCell, ref: tooltipRef }, value));
    return withTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { title: value, placement: "top-start", type: "HOVER" }, content)) : (react_1.default.createElement(react_1.default.Fragment, null, content));
});
//# sourceMappingURL=text-cell.js.map